import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.43351 14.625C7.43351 14.4179 7.68578 14.25 7.99697 14.25H14.4365C14.7477 14.25 15 14.4179 15 14.625C15 14.8321 14.7477 15 14.4365 15H7.99697C7.68578 15 7.43351 14.8321 7.43351 14.625Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.6827 3.43547C11.964 3.15664 12.3456 3 12.7434 3C12.9404 3 13.1354 3.03846 13.3174 3.11318C13.4994 3.18789 13.6647 3.29741 13.804 3.43547C13.9433 3.57353 14.0538 3.73744 14.1292 3.91782C14.2046 4.09821 14.2434 4.29154 14.2434 4.48679C14.2434 4.68204 14.2046 4.87538 14.1292 5.05576C14.0538 5.23615 13.9433 5.40005 13.804 5.53811L4.96535 14.2991L2.62634 14.8787C2.40468 14.9337 2.2039 14.7346 2.25931 14.5149L2.84406 12.1965L11.6827 3.43547Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }